<template>
  <ls-search-form :formList="formList" @search="onSearch" ref="searchForm">
    <template #warehouseCode>
      <global-select
        v-decorator="['warehouseCode']"
        requestApi="/system/lookup/data/list"
        @successCallBack="successCallBack"
        selectType="selectMultiple"
        :selectItem="{ value: 'lookupCode', label: 'lookupValue' }"
        :setParams="{ lookupType: '4PL_WAREHOUSE_DESCRIPTION', pageSize: 1000 }"
      />
    </template>
    <global-select
      slot="planType"
      v-decorator="['planType']"
      selectType="selectFilter"
      requestApi="/system/lookup/data/list"
      :selectItem="{ value: 'lookupCode', label: 'lookupValue' }"
      :setParams="{ lookupType: 'INV_ALLOCATION_PLAN_TYPE' }"
    />
    <template #requireDeliveryTime>
      <a-range-picker
        :allowClear="false"
        @openChange="openChange"
        :disabledDate="disabledDate"
        @calendarChange="calendarChange"
        v-decorator="['requireDeliveryTime', { initialValue: [$moment(), $moment()] }]"
      />
    </template>
  </ls-search-form>
</template>
<script>

// import moment from 'moment'
import cloneDeep from 'lodash.clonedeep'
export default {
  name: 'InboundExecutionReportSearch',
  data () {
    return {
      recordDate: null
    }
  },
  computed: {
    formList () {
      return [
        {
          label: "物料编码",
          type: "input",
          decorator: ['materialNo'],
          attrs: {
            placeholder: '请输入'
          }
        },
        {
          label: "物料名称",
          type: "input",
          decorator: ['materialName'],
          attrs: {
            placeholder: '请输入'
          }
        },
        {
          label: "入库仓",
          type: "warehouseCode",
          decorator: ['warehouseCode']
        },
        {
          label: "调度分类",
          type: "planType",
          decorator: ['planType']
        },
        {
          label: "是否有未安排数量",
          type: "select",
          decorator: ['arrangeQuantityIs'],
          options: [
            { key: 1, value: "是" },
            { key: 0, value: "否" }
          ],
          attrs: {
            placeholder: '请输入'
          }
        },
        //
        {
          label: "完成状态",
          type: "select",
          decorator: ['status'],
          options: [
            { key: '安排中', value: "安排中" },
            { key: '已关闭', value: "已关闭" }
          ],
          attrs: {
            placeholder: '请输入'
          }
        },
        {
          label: "要求到仓日期",
          type: "requireDeliveryTime",
          decorator: ['requireDeliveryTime']
        }
      ]
    }
  },
  methods: {
    disabledDate(current) {
      if (this.recordDate) {
        const start = cloneDeep(this.recordDate).startOf('day').subtract(7, 'days')
        const end = cloneDeep(this.recordDate).endOf('day').add(7, 'days')
        return current && (current <= start || current >= end)
      } else {
        return false
      }
    },

    openChange(val) {
      if (val) {
        this.recordDate = null
      }
    },
    calendarChange(value) {
      if (value.length === 1) {
        this.recordDate = cloneDeep(value[0])
      }
    },
    onSearch (val) {
      const params = val
      if(params && params.warehouseCode) {
        params.warehouseCode = params.warehouseCode.join(',')
      }
      this.$emit('search', params)
    },
    successCallBack(list) {
      const findName = ['基地仓', '青岛仓库', '佛山仓库']
      findName.forEach(e => {
        const findIndex = list.findIndex(x => x.lookupValue.indexOf(e) > -1)
        if (findIndex > -1) {
          const val = list[findIndex]
          list.splice(findIndex, 1)
          list.unshift(val)
        }
      })
    }
  }
}
</script>
